import React from 'react';
import EcoSection from 'eco-design/base/eco-section';
import EcoSpace from 'eco-design/base/eco-space';
import EcoVideo from 'eco-design/base/eco-video';
import style from './index.module.scss';
import { useLang } from '@/i18n';

interface Props {}

const Screen3: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.Screen3');

    return (
        <div className={`${style.comp} temp-Screen3 Screen3 GtmModuleData-section`} id="Screen3" data-section-id="Screen3">
            <EcoSpace />
            <EcoSection
                label={<img className="label-img" src="https://websiteoss.ecoflow.com/upload/image/1745568051826/icon.svg" loading="lazy" />}
                title={t.rich('title', {
                    s: (v: string) => <span>{v}</span>,
                })}
                desc={t.rich('desc', {
                    t: (i: string) => (
                        <span className="sub-desc" style={{ fontSize: '0.7em' }}>
                            {i}
                        </span>
                    ),
                })}
            />
            <EcoVideo
                autoPlay
                loop
                pc="https://websiteoss.ecoflow.com/upload/video/1729517560369/pc_1.mp4"
                h5="https://websiteoss.ecoflow.com/upload/video/1729517604583/m_1.mp4"
                poster="https://websiteoss.ecoflow.com/upload/image/1729655015843/pc1.jpg"
                posterH5="https://websiteoss.ecoflow.com/upload/image/1729655015812/m1.jpg"
            />
        </div>
    );
};
export default Screen3;
